import { API_ENDPOINT } from "./Api";
import { setCurrentUser } from "utils/utils";
import requestInstance from "./Request";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

//BillingList Service
export const billingListService = async (payload) => {

  const payloadData = {
    page: payload?.page === 0 || payload?.page ? parseInt(payload?.page) + 1 : 1,
    pageSize: payload?.pageSize || 10,
    status: payload?.status || "",
    location: payload?.city || "",
    company: payload.company || "",
    companyId: payload.companyId || "",
    fromDate: payload.fromDate || "",
    toDate: payload.toDate || "",
  }
  
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.operations.billing.billingListApi}?page=${payloadData?.page}&pageSize=${payloadData?.pageSize}&status=${payloadData?.status}&location=${payloadData?.location}&companyId=${payloadData?.companyId}&dateFrom=${payloadData?.fromDate}&dateTo=${payloadData?.toDate}`)
    .catch((err) => err.response);
    return setCurrentUser(res);
};

// Billing Get Invoice Details
export const billingInvoiceDetailsService = async (payload) => {
  let url;
  if (payload?.type === "public") {
    url = `${env}${API_ENDPOINT.operations.billing.bookinginvoiceDetails}?magicToken=${payload?.id}`;
  } else {
    url = `${env}${API_ENDPOINT.operations.billing.bookinginvoiceDetails}?tripId=${payload?.id}`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Get Price Details
export const billingPriceDetailsService = async (id) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.operations.billing.billingPriceDetails}?tripId=${id}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Billing Extra charges calculation API
export const billingExtraChargeCalcService = async (payload) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.operations.billing.bookingChargesCalculationApi}?tripId=${payload?.tripId}&extraTime=${payload?.extraTime}&extraDistance=${payload?.extraDistance}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// add Billing Price Details
export const addBillingPriceDetailsService = async (payload) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.operations.billing.billingPriceDetails}/${payload?.id}`, payload.obj)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Request Approval Service
export const billingRequestApprovalService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billingRequestForApproval}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Request Consolidated Invoice Service
export const billingConsolidatedInvoiceService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billingConsolidatedInvoiceApi}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Billing Generate Consolidated Invoice Service
export const getbillingConsolidatedInvoiceService = async (payload) => {
  let url;
  if (payload?.type === "public") {
    url = `${env}${API_ENDPOINT.operations.billing.consolidateInvoiceDetailApi}/?magicToken=${payload?.id}`;
  } else {
    url = `${env}${API_ENDPOINT.operations.billing.billingConsolidatedInvoiceApi}/${payload?.id}`;
  }
  const res = await requestInstance
    .get(url)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Billing Generate Invoice
export const billingGenerateInvoiceService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billingListApi}/${payload?.tripId}?type=${payload?.generateType}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const consolidateInvoiceMatrixService = async(payload) =>{
  let url;
  if(payload?.type === "public"){
  url =  `${env}${API_ENDPOINT.operations.billing.consolidateInvoiceMatrixApi}/?magicToken=${payload?.id}`;
  }
  else {
    url = `${env}${API_ENDPOINT.operations.billing.consolidateInvoiceMatrixApi}/${payload?.id}`
  }
  const res = await requestInstance
  .get(url)
  .catch((err) => err.response);
return setCurrentUser(res);
}

export const finalInvoiceService = async(payload) =>{
  let url = payload?.billingType === "billToCreditCard" ? "&billingType=1" : "";
  const page = payload?.page === 0 || payload?.page ? parseInt(payload?.page) + 1 : 1;
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.operations.billing.finalInvoiceApi}?page=${page}&pageSize=${payload?.pageSize || 10}&companyId=${payload?.companyId}&location=${payload?.city}&dateFrom=${payload?.fromDate}&dateTo=${payload?.toDate}${url}`)
  .catch((err) => err.response);
return setCurrentUser(res);
}

// Billing Request Approval Link
export const billingRequestApprovalLinkService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.operations.billing.billingRequestForApprovalLink}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};